<template>
  <router-view></router-view>
</template>

<script>
import MethodsVue from "../../components/local/vue2-dropzone/docs/src/pages/Methods.vue";

export default {
  name: "CouponRoot"
};
</script>
